import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getSelectedOrganization } from "../../../helpers/localStorage.ts";
import { useAppStore } from "../../../hooks/useStores";
import { useLogEvents } from "../../../hooks/useLogEvents";
import BriaButton, { ButtonTypes } from "../BriaButton/BriaButton";
import CopyToClipboardButton from "../CopyToClipboardButton/CopyToClipboardButton";
import styles from "./CopyApiTokenButton.module.scss";

type Props = {
	buttonType?: ButtonTypes;
};

const CopyApiTokenButton = ({ buttonType = "primaryMedium" }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "copyApiToken" });
	const { uiStore, appStore } = useAppStore();
	const { logImageGenerationComfyUCopyApiTokenClick } = useLogEvents();
	const productionApiKey = appStore.apiKeys.find((key) => key.key_type === "production");
	const selectedOrg = getSelectedOrganization();

	useEffect(() => {
		const loadData = async () => {
			if (!appStore.isError && appStore.apiKeys.length === 0) {
				await appStore.loadApiKeys();
			}
		};
		loadData();
	}, []);

	return (
		<>
			{selectedOrg ? (
				<CopyToClipboardButton
					textToCopy={productionApiKey?.api_token}
					buttonText={t("copyButton")}
					buttonType={buttonType}
					hideIcon
					loading={appStore.isLoading}
					afterCopyAction={logImageGenerationComfyUCopyApiTokenClick}
				/>
			) : (
				<BriaButton
					buttonType={buttonType}
					onClick={() => uiStore.showDialog("CreateOrganizationDialog")}
					className={styles.buttonText}
					loading={appStore.isLoading}
				>
					{t("getApiToken")}
				</BriaButton>
			)}
		</>
	);
};

export default observer(CopyApiTokenButton);
